import store from "@/store";

export async function openSuperLogicaClientArea() {
  let url =
    "https://brlgestao.superlogica.net/clients/areadocliente/clientes/formadepagamento";

  window.open(url, "_blank");
  store.dispatch("selfCheckoutSendSuperLogicaEmailPayment");
}
